const PREFIX = process.env.REACT_APP_BACKEND_URL + '/auth';

// API Handler for authentication module of backend server providing
// authentication related methods
export const AUTH_API = {
  login: async (email, password) => {
    const response = await fetch(`${PREFIX}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });
    const data = await response.json();
    return data;
  },
  requestForgotPassword: async (email) => {
    const response = await fetch(`${PREFIX}/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
    const data = await response.json();
    return data;
  },
  confirmResetPassword: async (password, token) => {
    const response = await fetch(`${PREFIX}/confirm-reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password, token }),
    });
    const data = await response.json();
    return data;
  },
  checkSession: async (userToken) => {
    const response = await fetch(`${PREFIX}/verify-token`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${userToken}`,
      },
    });
    const data = await response.json();
    return data;
  },
};
